import axios from 'axios';
import { BaseService } from '@/core/base-service';

export default class JournalService extends BaseService<any> {
	public constructor() {
		super('services/servicezef/api/journal');
	}

	public retrieveOverview(targetMonth: string | Date): Promise<any> {
		return axios.get(`${this.endpointName}/overview?month=${targetMonth}`);
	}
}
